export const EMBERCOM_PROSEMIRROR_COMPOSER_ALLOW_MOUSEDOWN_CLASS = 'embercom-prosemirror-composer-allow-mousedown';